import { render } from "./pick_up_pay.vue?vue&type=template&id=5303c368&scoped=true"
import script from "./pick_up_pay.vue?vue&type=script&lang=js"
export * from "./pick_up_pay.vue?vue&type=script&lang=js"

import "./pick_up_pay.vue?vue&type=style&index=0&id=5303c368&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5303c368"]])

export default __exports__